import { Paragraph, Link } from '@quickmd-llc/design-system';
import { useFilters } from '../';

export default function EmptyState(): JSX.Element {
  const { provider, resetFilters, timeOfDay } = useFilters();
  const showResetFilters = Boolean(timeOfDay || provider);

  function handleClick(event: React.MouseEvent<HTMLAnchorElement>) {
    event.preventDefault();

    resetFilters();
  }

  return (
    <div className="mt-10 flex items-center justify-center gap-4 text-center">
      <Paragraph size="sm">No available visits</Paragraph>
      {showResetFilters && (
        <Link to="" onClick={handleClick}>
          Reset Filters
        </Link>
      )}
    </div>
  );
}
